import { List, ListItem, Typography } from "@mui/material";

import { collaborationData } from "@/utils/staticData/becomeDealer";
import { FONT_PRIMARY, FONT_SECONDARY } from "@/theme/typography";
import useResponsive from "@/hooks/useResponsive";
import { listStyles } from "./styles";

const CollaborationList = () => {
  const isMobile = useResponsive("down", "md");

  return (
    <List disablePadding sx={listStyles}>
      {collaborationData.map(({ label, iconUrl }, index) => (
        <ListItem key={index} disablePadding sx={{ gap: { xs: 2, md: 3 } }}>
          <img
            src={iconUrl}
            alt={label}
            width={isMobile ? 24 : 32}
            height={isMobile ? 24 : 32}
          />
          <Typography
            variant="subtitle1"
            fontWeight={700}
            component="p"
            fontFamily={{ xs: FONT_SECONDARY, md: FONT_PRIMARY }}
          >
            {label}
          </Typography>
        </ListItem>
      ))}
    </List>
  );
};

export default CollaborationList;
